
import MainLayout from "@/components/layout/MainLayout";
import { Spinner } from "@/components/ui/spinner";

const AgentDetailSkeleton = () => {
  return (
    <MainLayout>
      <div className="flex items-center justify-center h-64">
        <Spinner size="lg" variant="muted" />
      </div>
    </MainLayout>
  );
};

export default AgentDetailSkeleton;
